import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const processed = useRef(false);
  const nav = useNavigate();
  const { onAuth } = useAuth();

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sid = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    if (!sid) { nav("/auth", { replace: true }); return; }
    api.post("/auth/oauth/session", { session_id: sid, origin_url: window.location.origin })
      .then((r) => {
        onAuth(r.data);
        toast.success(`Welcome, ${r.data.user.name}!`);
        nav("/my-learning", { replace: true, state: { user: r.data.user } });
      })
      .catch((e) => {
        toast.error(errMsg(e));
        nav("/auth", { replace: true });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <p className="p-10 pt-32 text-center text-[var(--forge-dim)]" data-testid="auth-callback-loading">Signing you in…</p>;
}
